import React from 'react';
import PropTypes from 'prop-types';
import { withInputAPI } from '@glu/validation-react';
import './themeDefaults';
import { AccessibilityText } from '@glu/utilities-react';
import useStyles from './Switch.styles';

const Switch = (props) => {
  const {
    className,
    dataQa,
    disabled,
    htmlId,
    labelOnLeft,
    labelText,
    name,
    onChange,
    screenReaderLabel,
    value
  } = props;

  const handleChange = () => {
    onChange(name, !value);
  };
  const classes = useStyles(props);

  const Label = () => (screenReaderLabel
    ? (
      <AccessibilityText>
        <span className={classes.labelText}>{labelText}</span>
      </AccessibilityText>
    )
    : <span className={classes.labelText}>{labelText}</span>);

  return (
    <label
      data-qa={dataQa}
      className={`${className} ${classes.root}`}
      htmlFor={htmlId}
    >
      {labelOnLeft && <Label />}
      <div className={classes.switchWrapper}>
        <input
          className={classes.switchInput}
          checked={value}
          id={htmlId}
          name={name}
          disabled={disabled}
          onChange={handleChange}
          type="checkbox"
        />
        <div className={classes.switchFill} />
      </div>
      {!labelOnLeft && <Label />}
    </label>
  );
};

Switch.propTypes = {
  className: PropTypes.string,
  dataQa: PropTypes.string,
  disabled: PropTypes.bool,
  htmlId: PropTypes.string.isRequired,
  labelOnLeft: PropTypes.bool,
  labelText: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  screenReaderLabel: PropTypes.bool,
  value: PropTypes.bool
};

Switch.defaultProps = {
  className: '',
  dataQa: 'switch,',
  disabled: false,
  labelOnLeft: false,
  screenReaderLabel: false,
  value: false
};

export const BaseSwitch = Switch;
export const ValidatedSwitch = withInputAPI(Switch);
ValidatedSwitch.displayName = 'Switch';
export default ValidatedSwitch;
